import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import Button from '@material-ui/core/Button'

//helpers
import Api from '../../../../__helpers/api'

//images
import closeIcon from '../../../../assets/images/profile/topic-info/close.png'
import transferIcon from '../../../../assets/images/dashboard/icons/transfer.png'

//modals
import QuestionModal from '../../../modals/Question'

//actions
import { refreshGroups } from '../../../../__actions/instructor'

//dispatcher
import { useDispatch } from 'react-redux'

function GroupsArchive(props, ref) {
    const dispatch = useDispatch()

    const [state, setState] = useState({
        blur: false,
        popup: false,
        data: [],
        refresh: new Date(),
        loading: true
    })

    const questionModalRef = useRef(null)

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose()
    }))

    const handleOpen = () => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
            }))
        }, 100)
    }

    const handleUnarchive = id => {
        questionModalRef.current.open({
            id
        })

    }

    useEffect(() => {
        loading(true)

        Api.get('center/groups/archived')
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data
                }))
            })
            .finally(() => {
                loading(false)
            })
    }, [state.blur, state.refresh])

    const loading = loading => {
        setState(prev => ({
            ...prev,
            loading
        }))
    }

    const handleConfirmUnarhive = data => {
        loading(true)
        Api.post('center/groups/unarchive', data)
            .then(() => {
                dispatch(refreshGroups())
                handleRefres()
            })
    }

    const handleRefres = () => {
        setState(prev => ({
            ...prev,
            refresh: new Date()
        }))
    }

    return (
        <div id="overlay" className={`group-archive-overlay ${state.blur ? 'visible' : ''}`}>
            <QuestionModal
                ref={questionModalRef}
                mainMessage="Повърждавате ли възстановяването на тази група?"
                secondaryMessage="След потвърждение, ще виждате групата в основния екран."
                handleConfirm={handleConfirmUnarhive}
            />
            <div className={`box group-archive ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                    style={{ filter: 'invert(65%) sepia(16%) saturate(313%) hue-rotate(154deg) brightness(91%) contrast(91%)' }}
                />
                <h3>
                    Архив на Вашите групи
                </h3>
                <ul>
                    {state.loading ?
                        <>
                            <Skeleton style={{ height: '40px' }} />
                            <Skeleton style={{ height: '40px' }} />
                            <Skeleton style={{ height: '40px' }} />
                            <Skeleton style={{ height: '40px' }} />
                            <Skeleton style={{ height: '40px' }} />
                        </>
                        :
                        state.data[0] ?
                            state.data.map(each =>
                                <li key={each.id}>
                                    <div className="left">
                                        <h4>
                                            {each.public_name}
                                        </h4>
                                        <h5>
                                            създадена на:<i className="date">Дата?</i>
                                        </h5>
                                        <h5>
                                            брой курсисти:<i className="count">{each.acceptedstudents_count}</i>
                                        </h5>
                                        <h5>
                                            архивирана на:<i className="archived-at">{each.archived_at}</i>
                                        </h5>
                                    </div>
                                    <Button onClick={() => handleUnarchive(each.id)}>
                                        <img
                                            src={transferIcon}
                                            className="transfer"
                                        />
                                        Премести в активни
                                    </Button>
                                </li>
                            )
                            :
                            <li className="no-data">
                                Няма няма архивирани групи.
                            </li>
                    }
                </ul>
            </div>
        </div >
    )
}

export default forwardRef(GroupsArchive)